module.exports = __webpack_public_path__ + "65252938de911044babf0f09845e9e7f.svg";